<template>
    <el-button
        type="primary"
        class="w-100"
        @click="handleShowFilterModal"
    >
        Select Filter Options
    </el-button>
    <el-dialog
        v-model="showCategoriesModal"
        title="Filter Options"
    >
        <div class="categorize-switch-controls text-center">
            <el-radio-group
                v-model="categorization_type"
                class="text-center"
            >
                <el-radio-button label="all">
                    All products
                </el-radio-button>
                <!--                <el-radio-button label="unmapped">-->
                <!--                    Unmapped-->
                <!--                </el-radio-button>-->
                <el-radio-button label="uncategorized">
                    Uncategorized
                </el-radio-button>
                <el-radio-button label="changed">
                    Changed Products
                </el-radio-button>
                <!--                <el-radio-button label="categorized">-->
                <!--                    Categorized-->
                <!--                </el-radio-button>-->
            </el-radio-group>
        </div>

        <div
            v-if="categorization_type === 'categorized'"
            class="mb-20"
        >
            <el-tree
                ref="tree"
                v-loading="loadTree"
                :data="treeData"
                node-key="path"
                show-checkbox
                lazy
                :load="loadNode"
                :props="treeProps"
            />
        </div>
        <el-form-item
            class="sugar-min-max"
            label="Sugar Per 100g"
            :label-width="180"
        >
            <div>
                <el-input
                    v-model="sugarData.sugar_per_100g_min"
                    min="0"
                    placeholder="Min"
                />
            </div>
            <span>-</span>
            <div>
                <el-input
                    v-model="sugarData.sugar_per_100g_max"
                    min="0"
                    placeholder="Max"
                />
            </div>
        </el-form-item>
        <el-form-item
            class="sugar-min-max"
            label="Net Carbs Per 100g"
            :label-width="180"
        >
            <div>
                <el-input
                    v-model="sugarData.net_carbs_per_100g_min"
                    min="0"
                    placeholder="Min"
                />
            </div>
            <span>-</span>
            <div>
                <el-input
                    v-model="sugarData.net_carbs_per_100g_max"
                    min="0"
                    placeholder="Max"
                />
            </div>
        </el-form-item>
        <el-form-item
            class="sugar-min-max"
            label="Total Weight (in grams)"
            :label-width="180"
        >
            <div>
                <el-input
                    v-model="sugarData.total_weight_min"
                    min="0"
                    placeholder="Min"
                />
            </div>
            <span>-</span>
            <div>
                <el-input
                    v-model="sugarData.total_weight_max"
                    min="0"
                    placeholder="Max"
                />
            </div>
        </el-form-item>


        <template #footer>
            <span class="dialog-footer">
                <el-button @click="handleClose">
                    Reset
                </el-button>
                <el-button
                    type="success"
                    @click="handleOk"
                >
                    Apply
                </el-button>
            </span>
        </template>
    </el-dialog>
</template>

<script setup>
import {useModelWrapper} from '~/includes/composable/modelWrapper'
import {computed, ref, watch} from 'vue'
import liProductsApi from '../../../labelinsight-products/liProductsApi'

const emit = defineEmits()

const props = defineProps({
    categorizationtype: {
        type: String,
        required: true
    },
    categoryFlats: {
        type: Array,
        required: true
    },
    sugarFilters: {
        type: Array,
        required: true
    },
})

const categorizationtype = useModelWrapper(props, emit, 'categorizationtype')
const category_flats = useModelWrapper(props, emit, 'categoryFlats')
const sugarFilters = useModelWrapper(props, emit, 'sugarFilters')

const tree = ref()
const showCategoriesModal = ref(false)
const treeData = ref([])
const treeProps = {
    children: 'children',
    label: 'name',
    isLeaf: 'isLeaf',
}
const treeKey = 0
const level = 0

const categorization_type = ref('uncategorized')
const category_paths = ref([])
const sugarData = ref({})


watch(
    () => category_paths.value,
    () => fillCategoryFlats(),
    { deep: true }
)

watch(
    () => sugarFilters.value,
    (value) => sugarData.value = _.cloneDeep(value),
    { deep: true }
)

function handleShowFilterModal() {
    showCategoriesModal.value = true
}

function handleOk() {
    categorizationtype.value = categorization_type.value
    if (categorization_type.value === 'categorized') {
        category_paths.value = tree.value.getCheckedKeys()
        emit('paths', category_paths.value)
    } else {
        emit('paths', [])
    }
    sugarFilters.value = _.cloneDeep(sugarData.value)


    showCategoriesModal.value = false
}

function handleClose() {
    clearSearch()
    showCategoriesModal.value = false
}

const loadTree = ref(false)

async function loadNode(node, resolve) {
    let path = node.data.path||''

    if (!path) loadTree.value = true
    const {data} = await liProductsApi.getByParents(path)
    loadTree.value = false
    let categories = data

    let pathLevel = 0
    if (path) {
        pathLevel = path.split('/').length
    }

    categories = categories.map((item) => {
        item.label = item.name
        item.isroot = (pathLevel === 0)
        item.isLeaf = (pathLevel === 4)

        return item
    })

    resolve(categories)
}

function removeFromList(index) {
    if (index > -1) {
        const tag_to_remove = category_paths.value[index]
        let i = 0
        category_paths.value.forEach(path => {
            if (tag_to_remove.includes(path)) category_paths.value.splice(i, 1)
            i++
        })
        tree.value.setCheckedKeys(category_paths.value)
    }
}

async function fillCategoryFlats() {
    let cat_flats = []
    const promises =  category_paths.value.map(async path => {
        const data = await getCategoryData(path)
        cat_flats.push(data)
        return path
    })
    await Promise.all(promises)
    category_flats.value = cat_flats
}

async function getCategoryData(path) {
    let response = await liProductsApi.getHierarchy(path)

    const levels = [
        'department',
        'superCategory',
        'category',
        'subCategory',
        'segment',
    ]
    let flatArray = {}
    levels.forEach((level) => {
        if (response.data[level]) {
            flatArray[level] = response.data[level].raw_name
        }
    })
    return flatArray
}

function clearSearch() {
    categorization_type.value = 'uncategorized'
    categorizationtype.value = 'uncategorized'
    category_paths.value = []
    emit('paths', category_paths.value)
    sugarFilters.value = {}
    sugarData.value = {}
    tree.value?.setCheckedKeys([])
}

defineExpose({ removeFromList, clearSearch })
</script>

<style lang="scss">
.sugar-min-max {
    margin-top: 20px;
    .el-form-item__content {
        display: flex;
        justify-content: space-between;
        > span {
            margin: 0 15px;
        }
        > div {
            width: 40%;
            .el-input__inner {
                //width: 50px;
            }
        }
    }
}
</style>
